<template>
    <div class="component">
        <vue-headful
        title="Edit Method | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="result" class="alert alert-secondary text-success font-weight-bold" role="alert">
            Тема успешно изменена!
        </div>
        <div class="form-group">
            <router-link class="btn bg-dark text-white" to="/admin/Methods">Вернуться назад</router-link>
        </div>
        <div class="form" v-for="method in MethodByIDGet" :key="method.method_id">
            <div class="form-group">
                <label for="theme" class="">Выберите тему</label>
                <select id="theme" class="custom-select bg-dark text-white" v-model="theme">
                    <option disabled>Выберите тему</option>
                    <option v-for="theme in AllThemesGet" :key="theme.theme_id" :value="theme.theme_id">
                        {{theme.theme_title}}
                    </option>
                </select>
            </div>
            <div class="form-group d-flex flex-column">
                <label for="title">Введите название</label>
                <div class="d-flex small">
                    <b>Текущее название:</b><span class="text-secondary ml-1">{{ method.method_title }}</span>
                </div>
                <input id="title" type="text" class="form-control" placeholder="Введите название" v-model="title"/>
            </div>
            <div class="form-group d-flex flex-column">
                <label for="link">Введите краткий адрес</label>
                <div class="d-flex small">
                    <b>Текущеий краткий адрес:</b><span class="text-secondary ml-1">{{ method.method_link }}</span>
                </div>
                <input id="link" type="text" class="form-control" placeholder="Введите краткий адрес" v-model="link"/>
                <small class="form-text text-muted">Например: user.get</small>
            </div>
            <div class="form-group d-flex flex-column">
                <label for="desc">Введите описание</label>
                <div class="d-flex small">
                    <b>Текущее описание:</b><span class="text-secondary ml-1" v-if="method.method_desc">{{ method.method_desc }}</span><span class="text-secondary ml-1" v-else>отсутствует</span>
                </div>
                <input id="desc" type="text" class="form-control" placeholder="Введите краткий адрес" v-model="desc"/>
            </div>
            <div class="form-group">
                <VueTrix v-model="content" placeholder="Введите содержимое" id="text" localStorage />
            </div>
            <button class="btn btn-dark" id="submit_btn" v-on:click="EditMethod">Редактировать тему</button>

        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import VueTrix from "vue-trix";
    Vue.use(VueTrix);
    export default {
        name: "MethodEdit",
        props: ['method_id_q'],
        data() {
            return {
                title: this.title,
                content: this.content,
                link: this.link,
                desc: this.desc,
                theme: this.theme,
                result: null,
                loading: true,
            };
        },
        components: {
            VueTrix,
        },
        computed: {
            AllThemesGet: function () {
                return this.$store.getters.AllThemesGet;
            },
            MethodByIDGet: function () {
                return this.$store.getters.MethodByIDGet;
            },
            MethodErrorGet: function () {
                return this.$store.getters.MethodErrorGet;
            },
            MethodSuccessGet: function () {
                return this.$store.getters.MethodSuccessGet;
            },
            AdminAuthInfoGet: function () {
                return this.$store.getters.AdminAuthInfoGet;
            },
        },
        methods: {
            EditMethod: function () {
                let AdminID = this.AdminAuthInfoGet.AdminID,
                AdminToken = this.AdminAuthInfoGet.AdminToken;
                this.$store.dispatch('MethodEditAct', [this.method_id, this.title, this.link, this.desc, AdminID, AdminToken]);

                if (this.MethodSuccessGet === true && this.MethodErrorGet.length === 0) {
                  this.result = true;
                  this.$store.dispatch('MethodByIDAct', this.method_id_q);
                  this.theme = this.title = this.content = this.link = this.desc = "";
              }
          },
      },
      mounted() {
        this.$store.dispatch('MethodByIDAct', this.method_id);
        this.content = this.MethodByIDGet[0].method_content;
        this.loading = false;
    },
    watch: {
        Method_id_q: function() {
            this.$store.dispatch('MethodByIDAct', this.method_id);
            this.$store.getters.MethodByIDGet;
        },
    },
}
</script>

<style scoped>

</style>
